<section class="page__header">
  <ep-space *ngIf="isMobile" [hasSafeArea]="true"></ep-space>
  <custom-app-bar *ngIf="!isMobile" [hasCloseButton]="true"></custom-app-bar>
</section>
<section class="page__content">
  <ep-space *ngIf="isMobile" [heightInPixels]="40"></ep-space>
  <ng-container *ngIf="isLoggedIn$ | async; else notLoggedIn">
    <div class="row">
      <h1
        class="title"
        *ngIf="user"
        [innerText]="'account.hello_name' | translate: { name: user.name }"
      ></h1>
      <svg-icon
        class="help-button"
        src="./assets/icons/help.svg"
        [routerLink]="['/', routesNames.contact] | localize"
      ></svg-icon>
    </div>
    <p *ngIf="currentDeliveryPoint$ | async as currentDeliveryPoint">
      {{
        "account.number_client_x"
          | translate: { code: currentDeliveryPoint.code }
      }}
    </p>
    <ul class="menu-entry-list">
      <ng-container *ngFor="let menuEntry of menuEntries">
        <li
          class="menu-entry"
          *ngIf="!menuEntry.hide"
          [routerLink]="menuEntry.url | localize"
        >
          <svg-icon
            class="menu-entry__icon"
            [src]="'./assets/icons/' + menuEntry.iconKey + '.svg'"
          ></svg-icon>
          <p class="menu-entry__name">
            {{ "account." + menuEntry.nameKey | translate }}
          </p>
          <svg-icon
            class="menu-entry__arrow"
            src="./assets/icons/right.svg"
          ></svg-icon>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <ng-template #notLoggedIn>
    <div class="row">
      <h1 class="title">{{ "account.not-logged-in-title" | translate }}</h1>
    </div>
    <div class="buttons">
      <button
        customButton
        expand="full"
        size="large"
        [routerLink]="['/', routesNames.login] | localize"
      >
        {{ "account.log-in-button" | translate }}
      </button>
      <button
        customButton
        expand="full"
        size="large"
        appearance="ghost"
        [routerLink]="['/', routesNames.signUp] | localize"
      >
        {{ "account.sign-up-button" | translate }}
      </button>
    </div>
  </ng-template>

  <ng-container *ngIf="isMobile">
    <ul class="menu-entry-list">
      <li
              class="menu-entry menu-entry--border-top"
              [class.menu-entry--border-top]="!(isLoggedIn$ | async)"
              (click)="openLanguageSelector()"
      >
        <svg-icon
                class="menu-entry__icon"
                [src]="'./assets/icons/globe.svg'"
        ></svg-icon>
        <p class="menu-entry__name">
          {{ "account.language"| translate }}
        </p>
        <svg-icon
                class="menu-entry__arrow"
                src="./assets/icons/right.svg"
        ></svg-icon>
      </li>
    </ul>
    <ng-container *ngIf="isLoggedIn$ | async">
      <h2 class="menu-list-title">
        {{ "account_config.menu_title" | translate }}
      </h2>
      <ul class="menu-entry-list">
        <li
          class="menu-entry"
          *ngFor="let menuEntry of configMenuEntries"
          [routerLink]="menuEntry.url | localize"
        >
          <svg-icon
            class="menu-entry__icon"
            [src]="'./assets/icons/' + menuEntry.iconKey + '.svg'"
          ></svg-icon>
          <p class="menu-entry__name">
            {{ "account_config." + menuEntry.nameKey | translate }}
          </p>
          <svg-icon
            class="menu-entry__arrow"
            src="./assets/icons/right.svg"
          ></svg-icon>
        </li>
      </ul>
      <button
        class="delete-account__button"
        customButton
        appearance="text"
        (click)="showDeleteAccountBottomSheet()"
      >
        {{ "account.delete_account" | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="isNativeApp">
      <h2 class="menu-list-title">{{ "account_config.support_title" | translate }}</h2>
      <ul class="menu-entry-list">
        <li class="menu-entry">
          <button
                  class="menu-entry-link"ç
                  (click)="shareApp()"
          >
            <svg-icon
                    class="menu-entry__icon"
                    src="./assets/icons/vector.svg"
            ></svg-icon>
            <p>{{"account_config.share_app" | translate }}</p>
          </button>
        </li>
      </ul>
    </ng-container>


    <h2 class="menu-list-title">{{ "legal_menu.title" | translate }}</h2>
    <ul class="menu-entry-list">
      <li class="menu-entry">
        <a
          class="menu-entry-link"
          [href]="'footer.terms_and_conditions_url' | translate"
        >
          <p class="menu-entry__name">
            {{ "legal_menu.legal_notice_and_terms_of_service" | translate }}
          </p>
          <svg-icon
            class="menu-entry__arrow"
            src="./assets/icons/right.svg"
          ></svg-icon>
        </a>
      </li>
      <li class="menu-entry">
        <a
          class="menu-entry-link"
          [href]="'privacy_policy.url' | translate"
        >
          <p class="menu-entry__name">
            {{ "legal_menu.privacy_settings" | translate }}
          </p>
          <svg-icon
            class="menu-entry__arrow"
            src="./assets/icons/right.svg"
          ></svg-icon>
        </a>
      </li>
    </ul>
  </ng-container>
</section>
<section class="page__footer">
  <div class="row">
    <button
      *ngIf="isLoggedIn$ | async"
      customButton
      appearance="text"
      (click)="logout()"
    >
      {{ "account.logout" | translate }}
    </button>
    <p>{{ versionName$ | async }}</p>
  </div>
</section>
